export function isObject(obj) {
    return typeof obj === "object" && obj !== null;
}

export function chunk(object, chunk) {
    let values = Object.values(object);
    let final = [];
    let counter = 0;
    let portion = {};

    for (let key in object) {
        if (counter !== 0 && counter % chunk === 0) {
            final.push(portion);
            portion = {};
        }
        portion[key] = values[counter];
        counter++;
    }
    final.push(portion);

    return final;
}

export function currencyFormat(value) {
    return new Intl.NumberFormat("fa-IR", {
        /*maximumSignificantDigits: 3*/
    }).format(value);
}

export function scroll(ref) {
    ref.current.scrollIntoView({ behavior: "smooth" });
}


